






















































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import cPopup from "@/components/default/Popup.vue";
import moment from "moment";
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxItem,
  DxLabel,
} from "devextreme-vue/form";
import notificationService from "@/services/notificationService";
import DxButton from "devextreme-vue/button";
import {
  CreatePlanningAgendaItemCommand,
  DeletePlanningAgendaItemCommand,
  GenerateMeasuringStatePlanningEndDateCommand,
  GetMeasuringStateForAgendaPopupQuery,
  MeasuringStateForAgenda,
  MeasuringStatesClient,
  PlanningAgendaItem,
  PlanningsClient,
  ProjectForPlanningViewModel,
  ProjectsClient,
  StringValueViewModel,
  Team,
  TeamsClient,
  UpdatePlanningAgendaItemCommand,
} from "@/data/web-api-client";
import Task from "@/classes/Task";
import Project from "@/classes/Project";
import contactsRepository from "@/services/contactsRepository";
import { indexOf } from "lodash";

@Component({
  components: {
    cPopup,
    DxSimpleItem,
    DxForm,
    DxLabel,
    DxRequiredRule,
    DxItem,
    DxGroupItem,
    DxButton,
  },
})
export default class AgendaPlanningItemPopup extends Vue {
  private planningItem: any = new PlanningAgendaItem();
  private teams: Team[] = [];
  private projects: ProjectForPlanningViewModel[] = [];
  private currentProject: ProjectForPlanningViewModel =
    new ProjectForPlanningViewModel();
  private members: string[] = [];
  private measuringStates: MeasuringStateForAgenda[] = [];
  private membersLoaded: boolean = false;
  private clickFromAgenda: boolean = true;
  private showDelete: boolean = true;

  private show: boolean = false;
  private loading: boolean = false;
  private saving: boolean = false;
  private isNew: boolean = false;

  private newTaskName: string = "";

  private taskOptions: any[] = [];

  public async Open(
    planningAgendaItem: PlanningAgendaItem,
    clickFromAgenda: boolean
  ) {
    this.planningItem = new PlanningAgendaItem();
    this.show = true;
    this.planningItem = planningAgendaItem;
    this.clickFromAgenda = clickFromAgenda;
    this.init();
  }

  private reset() {
    this.show = false;
  }

  private init() {
    this.getContacts();
    this.getTeams(false);
    this.getProjects();
    if (this.planningItem.id == "0") {
      this.getMeasuringStates();
    }

    this.members = [];
    if (this.planningItem.tasks == undefined) {
      this.planningItem.tasks = [];
    }
    if (this.planningItem.members == undefined) {
      this.planningItem.members = [];
    }

    if (this.planningItem.id == "0") {
      this.showDelete = false;
    } else {
      this.showDelete = true;
    }

    this.planningItem.newTaskName = "";

    this.taskOptions = this.getTasksOptions(this.planningItem.tasks);

    this.calculateEndDate();
  }

  private getTasksOptions(tasks: any) {
    const options = [];
    for (let i = 0; i < tasks.length; i += 1) {
      options.push(
        this.generateNewTaskOptions(
          tasks[i].name,
          tasks[i].checked,
          tasks[i].disabled
        )
      );
    }
    return options;
  }

  private generateNewTaskOptions(
    name: string,
    checked: boolean,
    disabled: boolean
  ) {
    return {
      location: "before",
      widget: "dxCheckBox",
      options: {
        text: name,
        width: 300,
        value: checked,
        disabled: disabled,
      },
    };
  }

  private Close() {
    this.show = false;
  }

  private mounted() {}

  private async getContacts() {
    let members = (
      await contactsRepository.getRelations(this.planningItem.subcontractorId!)
    ).data
      .filter((o: IBasicContact) => o.type === "Contact")
      .map((x: any) => x.displayName);

    members.forEach((member: string) => {
      if (!this.members.includes(member)) {
        this.members.push(member);
      }
    });
  }

  private async getTeams(refresh: boolean) {
    await new TeamsClient(undefined, this.$axios)
      .getAllTeamsForAgenda()
      .then((result) => {
        this.teams = result;
        if (refresh) {
          this.members = [];
          this.planningItem.members = [];
          let team = this.teams.find((x) => x.id == this.planningItem.teamId);
          if (team && team.members) {
            team.members!.forEach((x) => {
              if (!this.members.includes(x)) {
                this.members.push(x);
              }
              if (!this.planningItem.members!.includes(x)) {
                this.planningItem.members!.push(x);
              }
            });
          }
        }
        this.membersLoaded = true;
      });
  }

  private async getProjects() {
    this.projects = await new ProjectsClient(
      undefined,
      this.$axios
    ).getProjectsForAgenda();

    if (this.planningItem.projectId) {
      let project = this.projects.find(
        (x) => x.id == this.planningItem.projectId
      );
      if (project != null) {
        // this.planningItem.title = project.projectNumber + " - " + project.name;
        this.currentProject = project;
        this.setProjectTasks();
      }
    }
  }

  private async getMeasuringStates() {
    var result = await new MeasuringStatesClient(
      undefined,
      this.$axios
    ).getMeasuringStatesForAgendaPopup(
      new GetMeasuringStateForAgendaPopupQuery({
        start: new Date(),
        end: new Date(),
        searchValue: "",
        includeAll: true,
      })
    );
    this.measuringStates = result;
  }

  private setProjectTasks() {
    var task = this.planningItem.tasks!.find((x:any) => x.name == "Checkin@work");
    if (task == undefined && this.currentProject.checkinAtWorkTodo) {
      this.planningItem.tasks!.push(
        new StringValueViewModel({
          name: "Checkin@work",
          checked: this.currentProject.checkinAtWork,
          disabled: false,
        })
      );
    }

    task = this.planningItem.tasks!.find((x:any) => x.name == "Indienen VGM plan");
    if (
      task == undefined &&
      this.currentProject.provideSafetyHealthEnvironmentPlanTodo
    ) {
      this.planningItem.tasks!.push(
        new StringValueViewModel({
          name: "Indienen VGM plan",
          checked: this.currentProject.provideSafetyHealthEnvironmentPlan,
          disabled: false,
        })
      );
    }

    task = this.planningItem.tasks!.find(
      (x:any) => x.name == "Indienen risicoanalyse"
    );
    if (task == undefined && this.currentProject.provideRiskAnalysisTodo) {
      this.planningItem.tasks!.push(
        new StringValueViewModel({
          name: "Indienen risicoanalyse",
          checked: this.currentProject.provideRiskAnalysis,
          disabled: false,
        })
      );
    }

    task = this.planningItem.tasks!.find(
      (x:any) => x.name == "Attest BA verzekering doorsturen"
    );
    if (task == undefined && this.currentProject.provideInsuranceAttestTodo) {
      this.planningItem.tasks!.push(
        new StringValueViewModel({
          name: "Attest BA verzekering doorsturen",
          checked: this.currentProject.provideInsuranceAttest,
          disabled: false,
        })
      );
    }

    task = this.planningItem.tasks!.find(
      (x:any) => x.name == "Technische fiches doorsturen"
    );
    if (task == undefined && this.currentProject.provideTechnicalFilesTodo) {
      this.planningItem.tasks!.push(
        new StringValueViewModel({
          name: "Technische fiches doorsturen",
          checked: this.currentProject.provideTechnicalFiles,
          disabled: false,
        })
      );
    }
    this.taskOptions = this.getTasksOptions(this.planningItem.tasks);
  }

  private async save() {
    try {
      const form: any = this.$refs.planningForm;
      const validationResult = form.instance.validate();

      if (validationResult.isValid) {
        if (this.planningItem.id == "0") {
          this.planningItem.id = undefined;
          const success = await new PlanningsClient(
            undefined,
            this.$axios
          ).createAgendaItem(
            new CreatePlanningAgendaItemCommand({
              planningAgendaItem: this.planningItem,
              start: this.planningItem.start,
              end: this.planningItem.end,
            })
          );
          if (success) {
            this.Close();
          }
        } else {
          this.planningItem.dates = [];
          const success = await new PlanningsClient(
            undefined,
            this.$axios
          ).updateAgendaItem(
            new UpdatePlanningAgendaItemCommand({
              planningAgendaItem: this.planningItem,
            })
          );
          if (success) {
            this.Close();
          }
        }
      } else {
        notificationService.invalidForm();
      }
    } catch {
      notificationService.failedToSave();
    } finally {
      this.$emit("refresh");
    }
  }

  private async remove() {
    const success = await new PlanningsClient(
      undefined,
      this.$axios
    ).deleteAgendaItem(
      new DeletePlanningAgendaItemCommand({
        planningItemId: this.planningItem.id,
      })
    );
    if (success) {
      this.Close();
    }
    this.$emit("refresh");
  }

  get worktypesOptions() {
    const catalog = this.$store.getters["catalogs/list"](
      "WorkTypes"
    ) as ICatalogList;
    return { items: catalog ? catalog.values : [] };
  }

  get memberOptions() {
    return { items: this.members ? this.members : [], searchEnabled: true };
  }

  get measuringStateOptions() {
    return {
      items: this.measuringStates
        ? this.measuringStates.map((x: any) => x.documentNumber)
        : [],
      searchEnabled: true,
    };
  }

  get newTaskNameOption() {
    let self = this;
    return {
      options: {
        width: 50,
      },
      buttons: [
        {
          name: "trash",
          location: "after",
          options: {
            stylingMode: "text",
            icon: "plus",
            onClick: () => {
              var task = new StringValueViewModel();
              task.name = self.planningItem.newTaskName;
              task.checked = false;
              self.planningItem.tasks!.push(task);
              self.taskOptions = self.getTasksOptions(this.planningItem.tasks);
              self.planningItem.newTaskName = "";
            },
          },
        },
      ],
    };
  }

  get teamOptions() {
    return {
      dataSource: this.teams,
      valueExpr: "id",
      displayExpr: "title",
      searchEnabled: true,
    };
  }

  get projectOptions() {
    const self = this;
    return {
      dataSource: this.projects,
      valueExpr: "id",
      displayExpr: "name",
      searchEnabled: true,
      onValueChanged: (e: any) => {
        let project = self.projects.find((x) => x.id == e.value);
        if (project) {
          this.planningItem.title =
            project.projectNumber + " - " + project!.name;
        }
      },
    };
  }

  get titleOptions() {
    return {
      visible: false,
    };
  }

  get planningItemObject() {
    return this.planningItem;
  }

  private async fieldChanged(event: any) {
    if (event.dataField == "projectId") {
      this.currentProject = this.projects.find((x) => x.id == event.value)!;
      if (this.currentProject != undefined) {
        this.setProjectTasks();
      }
    }
    else if (event.dataField == "teamId") {
      // this.members = [];
      // this.planningItem.members = [];
      this.planningItem.teamId = event.value;
      await this.getContacts();
      await this.getTeams(true);
      const form: any = this.$refs.planningForm;
      form.instance.repaint();
    }
    else if (
      event.dataField == "measuringStateDocumentNumber" &&
      this.clickFromAgenda
    ) {
      var ms = this.measuringStates.find(
        (x) => x.documentNumber == event.value
      );
      if (ms != undefined) {
        this.planningItem.subcontractorId = ms!.subcontractorId;
      }
    }
  }

  private navigateToMeasuringState(documentNumber: string) {
    // this.loading = true;
    documentNumber = documentNumber.replaceAll("/", "-");
    var routeData = this.$router.resolve({
      path: `/measuringstates/${documentNumber}`,
    });
    window.open(routeData.href, "_blank");
  }

  private async calculateEndDate() {
    if(this.planningItem.start == undefined){
      return;
    }
    this.loading = true;
    this.planningItem.start = new Date(this.planningItem.start!)
    await new MeasuringStatesClient(undefined, this.$axios)
      .calculateEndDateForAgenda(
        new GenerateMeasuringStatePlanningEndDateCommand({
          start: this.planningItem.start,
          measuringStateDocumentNumber:
            this.planningItem.measuringStateDocumentNumber,
          inclusiveWeekend: this.planningItem.inclusiveWeekend,
          teamId: this.planningItem.teamId,
        })
      )
      .then((result) => {
        this.planningItem.end = new Date(result)
        this.loading = false;
        const form: any = this.$refs.planningForm;
        form.instance.repaint();
      });
  }
}
